// utils/chartDataTransform.js
export const transformReviewDataToDataset = (aggregatedDataByPosition, config) => {
    const datasets = {};

    Object.entries(aggregatedDataByPosition).forEach(([position, aggregatedData]) => {
        datasets[position] = Object.keys(aggregatedData)
            .filter(key => key in config)
            .map(key => {
                const { labelLeft, labelRight } = config[key];
                const label = aggregatedData[key] < 0 ? labelLeft : labelRight;

                return {
                    category: label,
                    value: Math.abs(aggregatedData[key]),
                };
            })
            .sort((a, b) => b.value - a.value);
    });

    return datasets;
};


// export const transformReviewDataToDataset = (aggregatedData, config) => {
//   return Object.keys(aggregatedData)
//     .filter(key => key in config)
//     .map(key => {
//       const { labelLeft, labelRight } = config[key];
//       const label = aggregatedData[key] < 0 ? labelLeft : labelRight;
//
//       return {
//         category: label,
//         value: Math.abs(aggregatedData[key]),
//       };
//     })
//     .sort((a, b) => b.value - a.value);
// };